import { Module } from 'vuex';
import { RootState } from '@/store/types';
import { StatisticState } from './types';
import { actions } from './actions';
import { mutations } from './mutations';
import { getters } from './getters';

export const state: StatisticState = {
  viberStatisticDetail: [],
  viberStatisticDetailFlag: undefined,
  viberStatisticGroup: [],
  viberStatisticGroupMessageCount: 0,
  viberGroupings: {
    viberGroup: [
      'hour',
      'day',
      'week',
      'month',
    ],
    viberGroupByOptionally: [
      'partner',
      'service_provider',
      'originator',
      'template_id',
      'bulk_id',
      'broker_account_login',
      'message_type',
    ],
  },
};

export const viberStatistic: Module<StatisticState, RootState> = {
  state,
  getters,
  actions,
  mutations
};
